<div #playerContainer [class]="classes"></div>
@if (!validOptions) {
	<div class="p-4">
		<p>Video mangler</p>
	</div>
}
